(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VideoPlayer"] = factory();
	else
		root["VideoPlayer"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VERSION = undefined;
	
	var _package = __webpack_require__(68);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _player = __webpack_require__(59);
	
	var _player2 = _interopRequireDefault(_player);
	
	var _metadata = __webpack_require__(56);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _embed = __webpack_require__(63);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _constants = __webpack_require__(60);
	
	var _logger = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _Voonto = Voonto,
	    $ = _Voonto.$;
	
	
	Voonto.ready.then(function (app) {
	  var config = app.lookup(_constants.CONFIG_NAMESPACE);
	  if (!config.serviceUrl) {
	    (0, _logger.showError)('service url is not defined within ' + _constants.CONFIG_NAMESPACE);
	    throw Error('[VideoPlayer] service url is not defined within ' + _constants.CONFIG_NAMESPACE);
	  }
	
	  if (!$('#' + _constants.MODAL_LAYER_ID).length) {
	    $('body').append('<div id="' + _constants.MODAL_LAYER_ID + '"></div>');
	  }
	
	  _init(config);
	
	  app.on('voonto:reload', function (event, context$) {
	    _init(config, context$);
	  });
	  app.on('videoplayer:refresh', function (event, context$) {
	    _init(config, context$);
	  });
	
	  // subscribe to visibility change events
	  document.addEventListener('visibilitychange', function () {
	    if (document.visibilityState === 'hidden') {
	      (0, _logger.showLog)('index.js::visibilitychange::hidden');
	      $('video').each(function () {
	        var video$ = $(this).get(0);
	        // pause video
	        if (video$ && !video$.paused) {
	          return video$.pause();
	        }
	        // pause ad
	        return setTimeout(function () {
	          if (video$ && typeof videojs !== 'undefined' && videojs(video$.id) && videojs(video$.id).ima3 && videojs(video$.id).ima3.adsManager) {
	            videojs(video$.id).ima3.adsManager.pause();
	          }
	        }, 0);
	      });
	    }
	    if (document.visibilityState === 'visible') {
	      (0, _logger.showLog)('index.js::visibilitychange::visible');
	    }
	  });
	});
	
	var VERSION = exports.VERSION = _package2.default.version;
	
	/* Private */
	
	function _init(config, context$) {
	  (0, _logger.showLog)('index::_init::Version ' + VERSION);
	  $('[data-voc-video-player]', context$).each(function () {
	    var container$ = $(this);
	    var options = {};
	
	    $.extend(options, _constants.DEFAULTS, {
	      source: container$.data('voc-video-player-source'),
	      accountname: container$.data('voc-video-player-accountname'),
	      videoid: container$.data('voc-video-player-videoid'),
	      autoplay: container$.data('voc-video-player-autoplay'),
	      author: container$.data('voc-video-player-author'),
	      bumperid: container$.data('voc-video-player-bumperid'),
	      controls: container$.data('voc-video-player-controls'),
	      description: container$.data('voc-video-player-description'),
	      domain: container$.data('voc-video-player-domain'),
	      edition: container$.data('voc-video-player-edition'),
	      link: container$.data('voc-video-player-link'),
	      loop: container$.data('voc-video-player-loop'),
	      longdescription: container$.data('voc-video-player-longdescription'),
	      modallayer: container$.data('voc-video-player-modallayer'),
	      muted: container$.data('voc-video-player-muted'),
	      name: container$.data('voc-video-player-name'),
	      newsid: container$.data('voc-video-player-newsid'),
	      playerid: container$.data('voc-video-player-playerid'),
	      playlistid: container$.data('voc-video-player-playlistid'),
	      playlistorientation: container$.data('voc-video-player-playlistorientation'),
	      playsinline: container$.data('voc-video-player-playsinline'),
	      poster: container$.data('voc-video-player-poster'),
	      template: container$.data('voc-video-player-template'),
	      src: container$.data('voc-video-player-src'),
	      videoad: container$.data('voc-video-player-videoad'),
	      videolive: container$.data('voc-video-player-videolive')
	    });
	
	    var metadata = new _metadata2.default(options, config.serviceUrl);
	    var player = new _player2.default(options, config.serviceUrl);
	    var embed = new _embed2.default({
	      metadata: metadata,
	      player: player,
	      container$: container$
	    });
	    embed.fetch();
	  });
	}

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Metadata = function () {
	  function Metadata(_ref, serviceUrl) {
	    var accountname = _ref.accountname,
	        source = _ref.source,
	        videoid = _ref.videoid;
	
	    _classCallCheck(this, Metadata);
	
	    this.metadata = {};
	    this.url = serviceUrl + '/videos/source/' + source + '/account/' + accountname + '/' + videoid + '.json';
	  }
	
	  _createClass(Metadata, [{
	    key: 'fetch',
	    value: function fetch() {
	      if (this.promise) {
	        return this.promise.then(function (json) {
	          return json.video.metadata;
	        });
	      }
	
	      this.promise = Voonto.$.ajax(this.url, {
	        dataType: 'json'
	      });
	
	      return this.promise.then(function (json) {
	        return json.video.metadata;
	      });
	    }
	  }]);
	
	  return Metadata;
	}();
	
	exports.default = Metadata;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(60);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Player = function () {
	  function Player(_ref, serviceUrl) {
	    var source = _ref.source,
	        accountname = _ref.accountname,
	        videoid = _ref.videoid,
	        autoplay = _ref.autoplay,
	        author = _ref.author,
	        bumperid = _ref.bumperid,
	        controls = _ref.controls,
	        description = _ref.description,
	        domain = _ref.domain,
	        edition = _ref.edition,
	        link = _ref.link,
	        loop = _ref.loop,
	        longdescription = _ref.longdescription,
	        modallayer = _ref.modallayer,
	        muted = _ref.muted,
	        name = _ref.name,
	        newsid = _ref.newsid,
	        playerid = _ref.playerid,
	        playlistid = _ref.playlistid,
	        playlistorientation = _ref.playlistorientation,
	        playsinline = _ref.playsinline,
	        poster = _ref.poster,
	        template = _ref.template,
	        src = _ref.src,
	        videoad = _ref.videoad,
	        videolive = _ref.videolive;
	
	    _classCallCheck(this, Player);
	
	    this.options = {
	      source: source,
	      accountname: accountname,
	      videoid: videoid,
	      autoplay: autoplay,
	      author: author,
	      bumperid: bumperid,
	      controls: controls,
	      description: description,
	      domain: domain,
	      edition: edition,
	      link: link,
	      loop: loop,
	      longdescription: longdescription,
	      modallayer: modallayer,
	      muted: muted,
	      name: name,
	      newsid: newsid,
	      playerid: playerid,
	      playlistid: playlistid,
	      playlistorientation: playlistorientation,
	      playsinline: playsinline,
	      poster: poster,
	      template: template,
	      src: src,
	      videoad: videoad,
	      videolive: videolive
	    };
	    this.url = serviceUrl + '/videos/source/' + source + '/account/' + accountname + '/' + videoid + '.html';
	  }
	
	  _createClass(Player, [{
	    key: 'fetch',
	    value: function fetch() {
	      var _this = this;
	
	      this.promise = Voonto.ready.then(function () {
	        return _getPromise.call(_this, window.__VOONTO__.getUserType());
	      }).catch(function () {
	        return _getPromise.call(_this, _constants.DEFAULT_USERTYPE);
	      });
	
	      return this.promise;
	    }
	  }]);
	
	  return Player;
	}();
	
	exports.default = Player;
	
	/* Private */
	
	function _getPromise(userType) {
	  this.options.videoad = !this.options.videoad ? this.options.videoad : _constants.USERTYPE_AD[userType];
	  this.url += '?' + _buildQueryString.call(this);
	  return Voonto.$.ajax(this.url, { dataType: 'html' });
	}
	
	function _buildQueryString() {
	  var _this2 = this;
	
	  var params = [];
	
	  Object.keys(this.options).forEach(function (option) {
	    if (_this2.options[option] || typeof _this2.options[option] === 'boolean') {
	      params.push({
	        key: option,
	        value: encodeURIComponent(_this2.options[option])
	      });
	    }
	  });
	
	  params.push({
	    key: 'isdesktop',
	    value: Voonto.is.desktop()
	  });
	
	  params.push({
	    key: 'language',
	    value: '' + _constants.LANGUAGE
	  });
	
	  return params.map(function (param) {
	    return param.key + '=' + param.value;
	  }).join('&');
	}

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONFIG_NAMESPACE = exports.CONFIG_NAMESPACE = 'vocento.config.multimedia.videoplayer';
	var LANGUAGE = exports.LANGUAGE = document.documentElement.lang && document.documentElement.lang.split('-').shift() || 'es';
	var LAZYLOAD_CLASS = exports.LAZYLOAD_CLASS = 'lazy';
	var EmbedStates = exports.EmbedStates = Object.freeze({
	  EMPTY: 0,
	  WITH_POSTER: 1,
	  WITH_PLAYER: 2
	});
	var VOCUSER_READY_PROMISE = exports.VOCUSER_READY_PROMISE = 'vocuser:ready';
	var MODAL_LAYER_ID = exports.MODAL_LAYER_ID = 'voc-video-player-modalcontainer';
	var MODAL_LAYER_PAYWALL_CONTENT_EVENT = exports.MODAL_LAYER_PAYWALL_CONTENT_EVENT = 'paywall:content';
	var MODAL_LAYER_TAG_MANAGER_SET_EVENT = exports.MODAL_LAYER_TAG_MANAGER_SET_EVENT = 'vtm:set';
	var MODAL_LAYER_BOOTSTRAP_OPTIONS = exports.MODAL_LAYER_BOOTSTRAP_OPTIONS = Object.freeze({
	  backdrop: true,
	  keyboard: true,
	  show: true
	});
	var DEFAULTS = exports.DEFAULTS = {
	  autoplay: false,
	  controls: true,
	  loop: false,
	  modallayer: false,
	  muted: false,
	  playsinline: true,
	  videoad: true,
	  videolive: false
	};
	var SOURCES = exports.SOURCES = Object.freeze({
	  BRIGHTCOVE: 'brightcove',
	  YOUTUBE: 'youtube',
	  VIMEO: 'vimeo',
	  DAILYMOTION: 'dailymotion',
	  UNKNOWN: 'unknown'
	});
	var DEFAULT_USERTYPE = exports.DEFAULT_USERTYPE = 'anonimo';
	var USERTYPE_AD = exports.USERTYPE_AD = Object.freeze({
	  anonimo: true,
	  registrado: true,
	  trial: false,
	  suscriptor: false
	});
	var SHOW_LOGS = exports.SHOW_LOGS = document.location.search.indexOf('debug=1') > -1;
	var DEFAULT_LOG_TEMPLATE = exports.DEFAULT_LOG_TEMPLATE = '[VideoPlayer]';

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(64);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _constants = __webpack_require__(60);
	
	var _logger = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var POSTER_TEMPLATE = '\n<img class="' + _constants.LAZYLOAD_CLASS + '" data-original="{poster}" width="100%" height="auto" />\n<noscript>\n  <img src="{poster}" width="100%" height="auto" />\n</noscript>\n';
	
	var EmbedView = function () {
	  function EmbedView(_ref) {
	    var metadata = _ref.metadata,
	        player = _ref.player,
	        container$ = _ref.container$;
	
	    _classCallCheck(this, EmbedView);
	
	    this.metadata = metadata;
	    this.player = player;
	    this.container$ = container$;
	    this.state = _constants.EmbedStates.EMPTY;
	  }
	
	  _createClass(EmbedView, [{
	    key: 'fetch',
	    value: function fetch() {
	      var _this = this;
	
	      this.container$.on('inview', function (event, isInView) {
	        if (isInView) {
	          // ISINVIEW
	          (0, _logger.showLog)('view.js::render::isInView');
	          var isViewEmpty = _this.state !== _constants.EmbedStates.WITH_POSTER && _this.state !== _constants.EmbedStates.WITH_PLAYER;
	          if (isViewEmpty) {
	            return _this.metadata.fetch().then(function (metadata) {
	              _this.metadata.metadata = metadata;
	            }).then(function () {
	              return _this.container$.attr('data-voc-video-player-processed', 'true');
	            }).then(function () {
	              return _this.render();
	            });
	          }
	          var _video$ = _this.container$.children().find('video').get(0);
	          // play video after ad
	          return setTimeout(function () {
	            if (_video$ && typeof videojs !== 'undefined' && videojs(_video$.id) && videojs(_video$.id).ima3 && videojs(_video$.id).ima3.adsManager) {
	              videojs(_video$.id).one('playing', function () {
	                videojs(_video$.id).play();
	              });
	            }
	          }, 0);
	        }
	        // NOT ISINVIEW
	        (0, _logger.showLog)('view.js::render::NOT-isInView');
	        var video$ = _this.container$.children().find('video').get(0);
	        // pause video
	        if (video$ && !video$.paused) {
	          videojs(video$.id).pause();
	          return video$.pause();
	        }
	        // pause video after ad
	        return setTimeout(function () {
	          if (video$ && typeof videojs !== 'undefined' && videojs(video$.id) && videojs(video$.id).ima3 && videojs(video$.id).ima3.adsManager) {
	            videojs(video$.id).one('playing', function () {
	              videojs(video$.id).pause();
	            });
	          }
	        }, 0);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.player.options.autoplay && !this.player.options.modallayer) {
	        this.isPlayerRendered();
	      } else {
	        this.isPosterRendered();
	      }
	    }
	  }, {
	    key: 'renderPoster',
	    value: function renderPoster() {
	      var _this2 = this;
	
	      if (!this.player.options.poster) {
	        this.player.options.poster = this.metadata.metadata.poster;
	      }
	      this.container$.append(POSTER_TEMPLATE.replace(/{poster}/g, this.player.options.poster));
	      setTimeout(function () {
	        return _this2.container$.find('.' + _constants.LAZYLOAD_CLASS).lazyload();
	      }, 0);
	      this.bindPosterEvents();
	      this.state = _constants.EmbedStates.WITH_POSTER;
	    }
	  }, {
	    key: 'renderPlayer',
	    value: function renderPlayer() {
	      Voonto.is.desktop() ? this.player.options.autoplay = true : this.player.options.autoplay = false;
	      if (this.player.options.modallayer) {
	        this.renderModal();
	      } else {
	        this.renderEmbed();
	      }
	      this.state = _constants.EmbedStates.WITH_PLAYER;
	    }
	  }, {
	    key: 'renderEmbed',
	    value: function renderEmbed() {
	      var _this3 = this;
	
	      this.container$.off('click');
	      this.player.fetch().then(function (player) {
	        _this3.container$.html(player);
	      });
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      var _this4 = this;
	
	      this.container$.off('click');
	      var modal = new _modal2.default(this.player, this.metadata.metadata);
	      modal.fetch().then(function () {
	        _this4.container$.on('click', function () {
	          return _this4.renderPlayer();
	        });
	      });
	    }
	  }, {
	    key: 'bindPosterEvents',
	    value: function bindPosterEvents() {
	      var _this5 = this;
	
	      this.container$.on('click', function () {
	        return _this5.renderPlayer();
	      });
	    }
	  }, {
	    key: 'isPosterRendered',
	    value: function isPosterRendered() {
	      if (this.state !== _constants.EmbedStates.WITH_POSTER && this.state !== _constants.EmbedStates.WITH_PLAYER) {
	        this.renderPoster();
	      }
	    }
	  }, {
	    key: 'isPlayerRendered',
	    value: function isPlayerRendered() {
	      if (this.state !== _constants.EmbedStates.WITH_PLAYER) {
	        this.renderPlayer();
	      }
	    }
	  }]);
	
	  return EmbedView;
	}();
	
	exports.default = EmbedView;

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(60);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AGENCY_PATTERN = '/AG-|PG-|AT-|EP-|JM-|ACB/g',
	    AGENCY = 'agen',
	    VIDEOS = 'videos',
	    VIDEO = 'video',
	    PHP = 'php';
	
	var ModalView = function () {
	  function ModalView(player, metadata) {
	    _classCallCheck(this, ModalView);
	
	    this.player = player;
	    this.metadata = metadata;
	    this.container$ = Voonto.$('#' + _constants.MODAL_LAYER_ID);
	  }
	
	  _createClass(ModalView, [{
	    key: 'fetch',
	    value: function fetch() {
	      var _this = this;
	
	      this.container$.empty();
	      return this.player.fetch().then(function (player) {
	        return _this.container$.html(player);
	      }).then(function () {
	        return _this.container$.children().first().modal(_constants.MODAL_LAYER_BOOTSTRAP_OPTIONS);
	      }).then(function () {
	        return _this.pauseVideos();
	      }).then(function () {
	        return _this.bindEvents();
	      }).then(function () {
	        return _this.renderSocialButtons();
	      }).then(function () {
	        return _this.renderMenuUnderline();
	      }).then(function () {
	        return _this.tracking();
	      }).then(function () {
	        Voonto.getInstance().trigger(_constants.MODAL_LAYER_PAYWALL_CONTENT_EVENT);
	      });
	    }
	  }, {
	    key: 'pauseVideos',
	    value: function pauseVideos() {
	      $('video').each(function () {
	        var video$ = $(this).get(0);
	        // pause video
	        if (video$ && !video$.paused) {
	          return video$.pause();
	        }
	        // pause ad
	        return setTimeout(function () {
	          if (video$ && typeof videojs !== 'undefined' && videojs(video$.id) && videojs(video$.id).ima3 && videojs(video$.id).ima3.adsManager) {
	            videojs(video$.id).ima3.adsManager.pause();
	          }
	        }, 0);
	      });
	    }
	  }, {
	    key: 'bindEvents',
	    value: function bindEvents() {
	      var _this2 = this;
	
	      this.container$.on('hide.bs.modal', function () {
	        return _this2.container$.empty();
	      });
	    }
	  }, {
	    key: 'renderSocialButtons',
	    value: function renderSocialButtons() {
	      if (this.metadata.link) {
	        this.container$.children().first().find('[data-voc-social-buttons]').socialButtons();
	      }
	    }
	  }, {
	    key: 'renderMenuUnderline',
	    value: function renderMenuUnderline() {
	      this.container$.children().first().find('[data-voc-animated-underline]').animatedUnderline();
	    }
	  }, {
	    key: 'tracking',
	    value: function tracking() {
	      var source = 'rl';
	
	      if (this.metadata.reference_id) {
	        source = this.metadata.reference_id.substr(0, 3);
	        source = source.match(AGENCY_PATTERN) ? AGENCY : source.split('-').shift().toLowerCase();
	      }
	
	      var subsecciones = [];
	
	      if (this.metadata.tags) {
	        var tags = this.metadata.tags;
	        var linkurl = this.metadata.linkurl ? this.metadata.linkurl : '';
	
	        Object.values(tags).forEach(function (tag) {
	          if (tag.indexOf('/main') !== -1) {
	            var cats = tag.replace('/main', '').split('/');
	            Object.values(cats).forEach(function (cat) {
	              subsecciones.push(cat.split('_').pop());
	            });
	            return false;
	          } else if (linkurl.indexOf('/' + tag + '/') !== -1) {
	            subsecciones = tag.split('/');
	          }
	          return true;
	        });
	      }
	
	      Voonto.getInstance().trigger(_constants.MODAL_LAYER_TAG_MANAGER_SET_EVENT, {
	        seccion: VIDEOS,
	        subseccion1: subsecciones[0] ? subsecciones[0] : '',
	        subseccion2: subsecciones[1] ? subsecciones[1] : '',
	        subseccion3: subsecciones[2] ? subsecciones[2] : '',
	        subseccion4: subsecciones[3] ? subsecciones[3] : '',
	        titular: this.metadata.name,
	        fechaPrimeraPublicacion: Voonto.moment(this.metadata.createdAt).format('YYYYMMDDkkmmss'),
	        fechaModificacion: Voonto.moment(this.metadata.updatedAt).format('YYYYMMDDkkmmss'),
	        tipoContenido: VIDEO,
	        sistemaPublicacion: PHP,
	        firmaAutor: this.metadata.author.name,
	        origenContenido: source
	      });
	    }
	  }]);
	
	  return ModalView;
	}();
	
	exports.default = ModalView;

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showLog = showLog;
	exports.showWarn = showWarn;
	exports.showError = showError;
	
	var _constants = __webpack_require__(60);
	
	function showLog() {
	  var _console;
	
	  _constants.SHOW_LOGS && (_console = console).log.apply(_console, [_constants.DEFAULT_LOG_TEMPLATE].concat(Array.prototype.slice.call(arguments)));
	}
	
	function showWarn() {
	  var _console2;
	
	  _constants.SHOW_LOGS && (_console2 = console).warn.apply(_console2, [_constants.DEFAULT_LOG_TEMPLATE].concat(Array.prototype.slice.call(arguments)));
	}
	
	function showError() {
	  var _console3;
	
	  _constants.SHOW_LOGS && (_console3 = console).error.apply(_console3, [_constants.DEFAULT_LOG_TEMPLATE].concat(Array.prototype.slice.call(arguments)));
	}

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	module.exports = {
		"name": "video-player",
		"version": "1.1.7",
		"description": "",
		"main": "src/index.js",
		"scripts": {
			"start": "webpack-dev-server",
			"build": "./node_modules/webpack/bin/webpack.js",
			"report": "plato -r -d report -l .jshintrc -t video-player src"
		},
		"contributors": [
			"Iván Pérez <ivanperez@vocento.com>",
			"Jose Manuel Ortega <jmortega@vocento.com>",
			"Adolfo Sanz <asanz@vocento.com>"
		],
		"license": "SEE LICENSE IN LICENSE.md",
		"devDependencies": {
			"babel-core": "^6.17.0",
			"babel-loader": "^6.2.5",
			"babel-preset-es2015": "^6.16.0",
			"chai": "^3.5.0",
			"chalk": "^1.1.3",
			"html-webpack-plugin": "^2.24.1",
			"json-loader": "^0.5.4",
			"mocha": "^3.1.0",
			"mocha-loader": "^1.0.0",
			"webpack": "^1.13.3",
			"webpack-shell-plugin": "^0.4.3"
		}
	};

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// video-player.js